var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    _vm.startwrap ? 'startwrap' : '' ,
    _vm.endwrap ? 'endwrap' : '',
    _vm.singleDayEvent ? 'singledayevent' : '',
    'event' ,
    _vm.eventClass,
    _vm.definition ? 'definition' : ''
  ],style:({
    'grid-row': _vm.gridRow,
    'grid-column': _vm.gridColumn,
    'align-self': _vm.align,
    'border-left-color': _vm.color,
    'background-color': _vm.backgroundColor,
    color: _vm.textColor
  })},[_vm._v(_vm._s(_vm.name))])}
var staticRenderFns = []

export { render, staticRenderFns }